import React, { createElement } from 'react';
import isNumber from 'lodash/isNumber';
import Style from './index.module.scss';

interface Width {
    type?: string;
    size?: number | string;
}

export interface ColProps {
    nodeId?: string;
    style?: object;
    width: Width;
    children: any;
}

const Col: React.FC<ColProps> = (props) => {
    const { nodeId, width, children, style } = props;

    const getStyle = (width: Width = {}) => {
        const { type, size } = width;
        const hasSize = size || isNumber(size);

        if (type && hasSize) {
            if (type === 'percentage') {
                return { flex: `0 0 auto`, width: `${size}%` };
            } else if (type === 'px') {
                return { flex: `0 0 auto`, width: `${size}px` };
            } else if (type === 'flex') {
                return { flex: `${size}` };
            } else {
                return { flex: '1' };
            }
        } else {
            return { flex: '1' };
        }
    };

    return (
        <div id={nodeId} className={Style.wrap} style={{ ...getStyle(width), ...style }}>
            {children}
        </div>
    );
};

export default Col;
